import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { VideoConferenceRoutingModule } from '../routers/video-conference-routing.module';
import { VideoCallComponent } from '../components/Video-calling/video-call/video-call.component';
import { ReactiveFormsModule,FormsModule } from '@angular/forms';
import { VideoContainerComponent } from '../components/Video-calling/video-container/video-container.component';
import { ScreenshareContainerComponent } from '../components/Video-calling/screenshare-container/screenshare-container.component';
import { LocalScreenshareContainerComponent } from '../components/Video-calling/local-screenshare-container/local-screenshare-container.component';
import { DominantSpeakerPipe } from '../pipes/dominant-speaker.pipe';
import { PreviewVideoCallComponent } from '../components/Video-calling/preview-video-call/preview-video-call.component';
import { LocalVideoStreamComponent } from '../components/Video-calling/local-video-stream/local-video-stream.component';
import { VideoCallEndedComponent } from '../components/Video-calling/video-call-ended/video-call-ended.component';
import { StartMeetingComponent } from '../components/Video-calling/start-meeting/start-meeting.component';


@NgModule({
  declarations: [
    VideoCallComponent,
    VideoContainerComponent,
    ScreenshareContainerComponent,
    LocalScreenshareContainerComponent,
    DominantSpeakerPipe,
    PreviewVideoCallComponent,
    LocalVideoStreamComponent,
    VideoCallEndedComponent,
    StartMeetingComponent
  ],
  imports: [
    CommonModule,
    VideoConferenceRoutingModule,
    ReactiveFormsModule,
    FormsModule
  ]
})
export class VideoConferenceModule { }
